import axios from 'axios'
import {backofficeUrl, baseUrl} from '../config'
import state from './state'

export default {
  login (login, password) {
    const body = {
      'login': login,
      'password': password,
    }
    console.log('body => ', body)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/auth/login', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  logout () {
    const body = {
      'revokedToken': localStorage.getItem('TOKEN')
    }
    console.log('body => ', body)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/auth/logout', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  fetchUserByUsername (login) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/userscs/username', login, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchAdminEmailByLogin (login) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/userscs/admins/username', login, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  forgotPassword (recipient, id) {
    const body = {
      'recipient': recipient,
      'link': backofficeUrl + '/resetPassword' + '/' + id
    }
    console.log('link  =>  ', backofficeUrl + '/resetPassword' + '/' + id)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/mail/send-email', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updatePassword (user) {
    console.log('ze user :: ', user)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/auth/pwd_reset', user, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  fetchAdministrators () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/userscs/admins', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createAdmin (admin) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/userscs/admin', admin, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createAgent (agent) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/userscs/agent', agent, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateUser (id, user) {
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/userscs/' + id, user, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchRondes () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/rondes', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchAgents () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/userscs/agents', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchAgentsList () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/userscs/agents/list', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchInterventions (id) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/rondes/' + id, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createRonde (ronde) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/rondes', ronde, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateRonde (id, ronde) {
    console.log('hello from update ronde')
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/rondes/' + id, ronde, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateIntervention (id, intervention) {
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/interventions/' + id, intervention, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateInterventionsOrder (interventions) {
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/interventions', interventions, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateAdresse (id, adresse) {
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/adresses/' + id, adresse, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchJalons () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/jalons', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchAdresses () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/adresses', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createIntervention (intervention) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/interventions', intervention, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  deleteIntervention (idIntervention) {
    console.log(idIntervention)
    return new Promise((resolve, reject) => {
      axios.delete(baseUrl + '/interventions/' + idIntervention, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  searchAdressesByNumero (numeroAdresse) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/adresses/search', numeroAdresse, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchTourneesOnlyByDate (date) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/tournees/only/search', date, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchTournee (tournee) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/tournees/search', tournee, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchAnomaliesByDates (dates) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/anomalies/search', dates, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchTourneesOnlyByDateForReporting (dates) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/tournees/only/reporting/search', dates, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchTourneesByDateForReporting (body) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/tournees/reporting/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  fetchImage (image) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/photos/' + image, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
}




// WEBPACK FOOTER //
// ./src/store/api.js